<div class="bg-white p-5 md:p-8 statics-page">
  <div class="flex flex-col gap-4 mb-6">
    <h1 class="text-2xl font-bold text-dc-navy">
      {{ "STATICS.PAGE_TITLE" | translate }}
    </h1>

    <form [formGroup]="filterForm" class="filters-form">
      <div class="filter-item">
        <app-option-field
          label=""
          placeholder="Membership"
          [options]="membershipAccounts"
          [labelKey]="'Name'"
          [valueKey]="'Value'"
          [control]="filterForm.get('membership')"
          (onSelectionChange)="onMembershipChange($event)"
          [showSelectedTooltip]="true"
        >
        </app-option-field>
      </div>     

      <div class="filter-item">
        <app-option-field
          label=""
          [placeholder]="'STATICS.ALL_SERVICES' | translate"
          [control]="filterForm.get('serviceName')"
          [lovType]="lookupKey.DC_SR_TYPE"
          [labelKey]="'Value'"
          [valueKey]="'Name'"
          [userType]="userType"
          [showSelectedTooltip]="true"
          (onSelectionChange)="onServiceChange($event)"
        >
        </app-option-field>
      </div>

       <div class="filter-item">
        <app-option-field
          label=""
          placeholder=""
          [lovType]="lookupKey.DC_REPORT_PERIOD"
          [control]="filterForm.get('reportPeriod')"
          [labelKey]="'Value'"
          [valueKey]="'Name'"
          [showSelectedTooltip]="true"
          (onSelectionChange)="onReportPeriodChange()"
        >
        </app-option-field>
      </div>

      @if (showCustomDateRange) {
        <div class="filter-item filter-item-date">
          <div class="relative">
            <input
              type="text"
              class="calendar-field"
              [placeholder]="'PAYMENTS.FILTER.DATE_FROM' | translate"
              [value]="dateFromDisplay"
              readonly
              (click)="toggleDateCalendar('from')"
            />
            <button
              type="button"
              class="calendar-field-icon"
              (click)="toggleDateCalendar('from')"
            >
              <i class="fas fa-calendar"></i>
            </button>
            @if (dateFromDisplay) {
              <button
                type="button"
                class="calendar-field-clear"
                (click)="clearDateFrom($event)"
                aria-label="Clear date from"
              >
                <i class="fas fa-times"></i>
              </button>
            }
            @if (showDateFromCalendar) {
              <div class="absolute z-50 mt-2">
                <app-inline-calendar
                  [selected]="selectedDateFrom || today"
                  [disablePast]="false"
                  [disableFuture]="true"
                  (onDatePicked)="onDateFromPicked($event)"
                ></app-inline-calendar>
              </div>
            }
          </div>
        </div>

        <div class="filter-item filter-item-date">
          <div class="relative">
            <input
              type="text"
              class="calendar-field"
              [placeholder]="'PAYMENTS.FILTER.DATE_TO' | translate"
              [value]="dateToDisplay"
              readonly
              (click)="toggleDateCalendar('to')"
            />
            <button
              type="button"
              class="calendar-field-icon"
              (click)="toggleDateCalendar('to')"
            >
              <i class="fas fa-calendar"></i>
            </button>
            @if (dateToDisplay) {
              <button
                type="button"
                class="calendar-field-clear"
                (click)="clearDateTo($event)"
                aria-label="Clear date to"
              >
                <i class="fas fa-times"></i>
              </button>
            }
            @if (showDateToCalendar) {
              <div class="absolute z-50 mt-2">
                <app-inline-calendar
                  [selected]="selectedDateTo || today"
                  [disablePast]="false"
                  [disableFuture]="true"
                  [minDate]="selectedDateFrom"
                  (onDatePicked)="onDateToPicked($event)"
                ></app-inline-calendar>
              </div>
            }
          </div>
        </div>
      }
    </form>
  </div>

  <div class="statistics-card mb-6">
    <h2 class="statistics-section-title text-dc-navy">
      {{ selectedServiceLabel || ('STATICS.ALL_SERVICES' | translate) }}
    </h2>

    @if (isStatusChartLoading) {
      <app-skeleton-loader></app-skeleton-loader>
    }

    @if (!isStatusChartLoading && noStatusCountData) {
      <div class="mb-3 text-sm font-semibold text-dc-orange">
        {{ "STATICS.NO_DATA_FOUND" | translate }}
      </div>
    }

    @if (!isStatusChartLoading && !noStatusCountData) {
      <div class="status-layout px-9">
        <div class="status-chart-wrap">
          <app-chart
            [chartType]="'doughnut'"
            [chartData]="statusDonutChartData"
            [height]="320"
          >
          </app-chart>
          <div class="status-total-chip">{{ statusTotalDisplay }}</div>
        </div>

        <div class="status-rows">
          @for (row of statusCountRows; track row.serviceStatus + '_' + $index) {
            <div class="status-row-item px-0 sm:px-9">
              <div class="status-row-head">
                <span class="status-name">{{ row.serviceStatus }}</span>
                <span class="status-value">{{ formatNumber(row.srCount) }}</span>
              </div>
              <div class="status-track">
                <span
                  class="status-fill"
                  [style.background]="row.color"
                  [style.width.%]="row.widthPercent"
                ></span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="statistics-card">
    <h2 class="statistics-section-title text-dc-navy">
      {{ "STATICS.PAYMENT_TREND_OVER_MONTHS" | translate }}
    </h2>

    @if (isSpendingChartLoading) {
      <app-skeleton-loader></app-skeleton-loader>
    }

    @if (!isSpendingChartLoading && noSpendingData) {
      <div class="mb-3 text-sm font-semibold text-dc-orange">
        {{ "STATICS.NO_DATA_FOUND" | translate }}
      </div>
    }

    @if (!isSpendingChartLoading && !noSpendingData) {
      <app-chart
        [chartType]="'bar'"
        [chartData]="spendingBarChartData"
        [height]="360"
      >
      </app-chart>
    }
  </div>
</div>
